import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const Ffg = ({featuredProjectsList}) => {
  const project = getProject('fashion-for-good');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <Image
          className=""
          component={{
            image: '/ffg/0-ffg-Hero.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2>A new chapter for the fashion industry</h2>
          <p>
            The fashion industry is plagued with the label of being a global pollutant.{' '} 
            To fix that, <a href="www.fashionforgood.com" target="_blank">Fashion For Good</a> was created and set out on a mission towards a more sustainable chapter for fashion.
          </p>
          <p>
            After starting an innovation hub in Amsterdam, a startup accelerator in Silicon Valley, and a network of changemakers, 
            Fashion For Good tasked Your Majesty with bringing its new brand identity to life online. 
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '/ffg/1-ffg-Web.jpg'
          }}
        />
    
        <AnimateIn className="text g-row">
          <p>
            After the launch of the new website, Your Majesty was appointed as the digital agency of record, 
            consulting Fashion For Good on all of digital initiatives 
          </p>
        </AnimateIn>

        <Image 
          className=""
          component={{
            image: '/ffg/2-ffg-Exhibition.jpg',
           caption: 'At the Fashion For Good Experience, visitors can learn about the dark history of the industry and discover its bright future.'
          }}
        />

        <AnimateIn className="text g-row">
          <h2>The fashion for good Experience</h2>
          <p>
            In 2018, Fashion For Good opened the <a href="https://fashionforgood.com/the-experience/" target="_blank">world’s first interactive museum for sustainable fashion.</a>
            <br/><br/>
            For the opening, Your Majesty created a series of digital education stations throughout the museum. 
          </p>
        </AnimateIn>
  
        <Image 
          className=""
          component={{
            image: '/ffg/3-ffg-Exhibition.jpg'
          }}
        />

        <Quote 
          className="g-row"
          component={{
            quote:
              '"Your Majesty was the perfect sparring partner to bring our website and digital touchpoints to life - delivering on strategy, technical expertise, design execution, and project management to get the job done to a super high standard."',
            quotee: 'Nicola Mitchell, Digital Marketing Manager'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="look-to-innovate">Looking to innovate?</h2>
          <p>
            Reach out to{' '}
            <a href="mailto: hello@yourmajesty.co">
              hello@yourmajesty.co
            </a>{' '}
            to learn about how we can help you get off the ground.
          </p>
          
          <h2 id="like-what-you-see">More fashion and apparel</h2>
          <p>
            Check out <a href="https://medium.com/your-majesty-co/digital-fashion-a-new-essential-7ee93e7c0eb7" target="_blank">Digital Fashion: A New Essential</a>, 
    {' '}<a href="/work/i-t-hong-kong">I.T Hong Kong</a>, <a href="/work/fila">FILA Explore</a> or <a href="/work/rottefella">Rottefella</a>.
          </p>
           
        </AnimateIn>

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Insights & Strategy',
                items: [
                  'Data Analysis',
                  'Content & Analytics Audit',
                  'Expert Reviews',
                  'Site Performance Analysis',
                  'Quantitative User Research',
                  'Qualitative User Research',
                  'A/B Testing',
                  'Digital Strategy',
                  'Workshop & Facilitation'
                ]
              },

              {
                title: 'Design',
                items: [
                  'Art Direction',
                  'Creative Direction',
                  'Visual Design',
                  'UI/UX Design',
                  'Motion Design',
                  '3D Design',
                  '3D Animation'
                ]
              },

              {
                title: 'Technology',
                items: ['Front-end Development', 'Back-end Development', 'WebGL', 'Back-end Development', 'Wordpress CMS', 'Localization', 'Systems Architecture', 'Prototyping' ]
              },
            
            {
                title: 'Delivery & Aftercare',
                items: ['Quality Assurance', 'Deployment', 'Integration Support', 'Staff Training Support', 'Service Level Agreement', 'Operations & Maintenance' ]
              }
              
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default Ffg;
